import Tabs from "components/tabs"
import intl from "react-intl-universal";
import GridParameterizationContent from "./components/grid-parameterization-content";
import { GridParameterizationProvider } from "./context";

const GridParameterization = () => {
  const gridParameterizationContent = [
    {
      key: 1,
      label: intl.get("master-data.managementUnity.grid.dischargeDegree.header.title"),
      content: (
        <GridParameterizationContent key="unload-capacity" type="unload-capacity" />
      )
    },
    {
      key: 2,
      label: intl.get("master-data.managementUnity.grid.loadingGrid.header.title"),
      content: (
        <GridParameterizationContent key="load-capacity" type="load-capacity" />
      )
    }
  ];

  return (
    <GridParameterizationProvider>
      <Tabs tabsContent={gridParameterizationContent} />
    </GridParameterizationProvider>
  );
}

export default GridParameterization;
